import { render } from "./goodsTag.vue?vue&type=template&id=2aede9bd&scoped=true"
import script from "./goodsTag.vue?vue&type=script&lang=js"
export * from "./goodsTag.vue?vue&type=script&lang=js"

import "./goodsTag.vue?vue&type=style&index=0&id=2aede9bd&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2aede9bd"]])

export default __exports__